import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { readTask, writeTask } from '@stencil/core/internal/client';
import { c as componentOnReady } from './helpers.js';

var startStatusTap = function startStatusTap() {
  var win = window;
  win.addEventListener('statusTap', function () {
    readTask(function () {
      var width = win.innerWidth;
      var height = win.innerHeight;
      var el = document.elementFromPoint(width / 2, height / 2);

      if (!el) {
        return;
      }

      var contentEl = el.closest('ion-content');

      if (contentEl) {
        new Promise(function (resolve) {
          return componentOnReady(contentEl, resolve);
        }).then(function () {
          writeTask( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    /**
                     * If scrolling and user taps status bar,
                     * only calling scrollToTop is not enough
                     * as engines like WebKit will jump the
                     * scroll position back down and complete
                     * any in-progress momentum scrolling.
                     */
                    contentEl.style.setProperty('--overflow', 'hidden');
                    _context.next = 3;
                    return contentEl.scrollToTop(300);

                  case 3:
                    contentEl.style.removeProperty('--overflow');

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })));
        });
      }
    });
  });
};

export { startStatusTap };